/**
 * EliorGroup.Joyfood.Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RatingDisplayOptions = null | null | null | null;

export const RatingDisplayOptions = {
    NUMBER_null: null as RatingDisplayOptions,
    NUMBER_null2: null as RatingDisplayOptions,
    NUMBER_null3: null as RatingDisplayOptions,
    NUMBER_null4: null as RatingDisplayOptions
};

